import type { InternalAuditEntityRegisterResponseRow } from '@risksmart-app/drizzle/src/dto';
import type {
  GetInternalAuditsQuery,
  Internal_Audit_Entity_Bool_Exp,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import {
  GetInternalAuditsDocument,
  Parent_Type_Enum,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook, type StrictMappedGraphQLSelection } from 'src/utils';

import useEntityWhereFilter from '@/hooks/useEntityWhereFilter';

/**
 * Maps TRPC internal audit entities data to match the GraphQL query structure
 */
export const mapTrpcInternalAuditEntitiesToGraphQL = (
  trpcData: InternalAuditEntityRegisterResponseRow[] | undefined
): StrictMappedGraphQLSelection<GetInternalAuditsQuery> | undefined => {
  if (!trpcData) {
    return undefined;
  }

  return {
    internal_audit_entity: trpcData,
  };
};

const useInternalAuditsGraphqlVariables = () => {
  const whereFilter = useEntityWhereFilter<Internal_Audit_Entity_Bool_Exp>(
    Parent_Type_Enum.InternalAuditEntity
  );

  return { where: whereFilter };
};

type UseGetInternalAuditEntitiesRegisterArgs = Record<string, never>;

export const useGetInternalAuditEntitiesRegister = createQueryHook<
  UseGetInternalAuditEntitiesRegisterArgs,
  InternalAuditEntityRegisterResponseRow[],
  GetInternalAuditsQuery
>({
  trpcQueryOptions: (trpc) =>
    trpc.frontend.internalAuditEntity.register.queryOptions(),
  mapTrpcDataToGraphQL: (data) => ({
    internal_audit_entity: data,
  }),
  graphqlDocument: GetInternalAuditsDocument,
  graphqlVariables: useInternalAuditsGraphqlVariables,
});
